import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { postPAIAE010 } from '../../../services/Api';
import Dropdown from '../../../shared/components/Dropdown';
import Pagination from '../../../shared/components/Pagination';
import RecruitItem from '../../../shared/components/RecruitItem';
import SideNav from '../../../shared/components/SideNav';
import PAEAA060 from '../../Recruit/PAEAA010/popupPAEAA060';
const PAIAE010 = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);

    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [data, setData] = useState([]);
    const [sortBy, setSortBy] = useState('ChoiceSeq');

    const handleOptionChange = (selectedValue) => {
        setSortBy(selectedValue);
    };
    const getListData = async () => {
        try {
            // const sortType = sortBy === 'AddDate' ? 'DESC' : 'ASC';
            const { data } = await postPAIAE010({ page, sortBy, sortType: 'ASC' });
            setData(data.data);
            setPages(data.info);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getListData();
        //eslint-disable-next-line
    }, [page]);
    const openPopup = (data) => {
        setPopupData(data);
        setIsPopupOpen(true);
    };
    const closePopup = () => {
        setIsPopupOpen(false);
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, sortBy]);

    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">
                                    스크랩 <span>* 최근 3개월 이내 스크랩한 채용정보를 확인할 수 있습니다.</span>
                                </h3>
                                <div className="scrap__select">
                                    <Dropdown
                                        placeholder=""
                                        options={[
                                            { value: 'ChoiceSeq', option: '스크랩일순' },
                                            { value: 'RecruitEnd', option: '마감임박순' },
                                            { value: 'AddDate', option: '등록일순' },
                                        ]}
                                        value={sortBy}
                                        onChange={handleOptionChange}
                                    />
                                </div>
                                <div id="notification-tab" className="mtch__list mtch__list--mt10">
                                    <div className="header-table-container" style={{ borderTop: '1px solid #111' }}>
                                        <div
                                            className="table table-header table__header-5col"
                                            style={{ marginTop: '0' }}
                                        >
                                            <div className="column column-1">치과명</div>
                                            <div className="column column-3">
                                                <div>
                                                    제목/담당업무/위치
                                                </div>
                                                <div>경력/형태/자격증/수정</div>
                                                <div>마감일</div>
                                                <div>관리</div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="table wrap-table">
                                        {data && data.length ? (
                                            data.map((item, index) => (
                                                <RecruitItem
                                                    item={item}
                                                    key={index}
                                                    saveHistory={false}
                                                    openPopup={openPopup}
                                                    showStar={false}
                                                    refreshData={getListData}
                                                    showDelete={true}
                                                />
                                            ))
                                        ) : (
                                            <li className="no-data">데이터없습니다</li>
                                        )}
                                    </ul>
                                </div>
                                <Pagination pages={pages} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isPopupOpen && <PAEAA060 closePopup={closePopup} popupData={popupData} />}
        </>
    );
};

export default PAIAE010;
